export default __webpack_public_path__ + "static/about-6b69e0a13e582caf8bcb47f192db0f9a.png";